(() => {
  if (customElements.get('zeesy-infinite-scroll')) return;
  class ZeesyInfiniteScroll extends HTMLElement {
    connectedCallback() {
      this.link = this.querySelector('[data-scroll-more]');
      this.busy = false;
      this.failed = false;
      this.check = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          if (!this.failed && this.getBoundingClientRect().top < innerHeight + 700) this.load();
        });
      };
      this.click = event => {
        if (!event.target.closest('[data-scroll-more]')) return;
        event.preventDefault();
        this.failed = false;
        this.load();
      };
      this.addEventListener('click', this.click);
      addEventListener('scroll', this.check, { passive: true });
      addEventListener('resize', this.check);
      this.observer = new IntersectionObserver(this.check, { rootMargin: '700px' });
      this.observer.observe(this);
      this.check();
    }
    disconnectedCallback() {
      removeEventListener('scroll', this.check);
      removeEventListener('resize', this.check);
      this.removeEventListener('click', this.click);
      this.observer?.disconnect();
      this.controller?.abort();
      cancelAnimationFrame(this.frame);
    }
    async load() {
      if (this.busy || !this.dataset.url || !this.isConnected) return;
      const grid = document.getElementById(this.dataset.containerId);
      if (!grid) return;
      this.busy = true;
      this.setAttribute('aria-busy', 'true');
      this.controller = new AbortController();
      const timeout = setTimeout(() => this.controller.abort(), 20000);
      try {
        const url = new URL(this.dataset.url, location.origin);
        const preview = new URLSearchParams(location.search).get('preview_theme_id');
        if (preview) url.searchParams.set('preview_theme_id', preview);
        const section = this.closest('[id^="shopify-section-"]');
        if (section) url.searchParams.set('section_id', section.id.replace('shopify-section-', ''));
        const response = await fetch(url, { signal: this.controller.signal });
        if (!response.ok) throw new Error('Pagination response failed');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const results = html.getElementById(this.dataset.containerId);
        const cards = results?.querySelectorAll('.' + this.dataset.target);
        if (!cards?.length) throw new Error('Pagination products missing');
        if (!this.isConnected || !grid.isConnected) return;
        const fragment = document.createDocumentFragment();
        cards.forEach(card => fragment.append(card));
        const position = scrollY;
        grid.append(fragment);
        void grid.offsetHeight;
        if (scrollY !== position) scrollTo(0, position);
        const next = html.querySelector('zeesy-infinite-scroll');
        if (!next?.dataset.url) { this.remove(); return; }
        this.dataset.url = next.dataset.url;
        this.link.href = next.dataset.url;
      } catch (error) {
        this.failed = true;
      } finally {
        clearTimeout(timeout);
        this.busy = false;
        this.removeAttribute('aria-busy');
      }
      if (!this.failed && this.isConnected) this.check();
    }
  }
  customElements.define('zeesy-infinite-scroll', ZeesyInfiniteScroll);
})();

